<!--
 * @Description: 办理过程
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-04-15 10:09:00
 * @LastEditTime: 2019-04-15 11:03:28
 -->
<template>
    <section class="event-coures">
        <z-title :title="data.state" :icon="icon" />
        <div class="content">
            <user-result :data="item" v-for="(item, index) in data.result" :key="index" :event="event" :taskid="taskid" :communityId="communityId" />
        </div>
    </section>
</template>
<script>
import ZTitle from "../../../components/EventHeader"
import UserResult from "./UserResult.vue"
export default {
    props: {
        data: [Object],
        icon:[String],
        event: [Object],
        taskid: [String],
      communityId:[String]
    },
    data() {
        return {

        };
    },
    components: { UserResult,ZTitle },
    computed: {},
  mounted(){
      console.log(this.data)
  }
}
</script>
<style lang='less' scoped>
.event-coures {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    .content {
        width: 100%;
        padding: 20px;
    }
    .item-content {
        word-wrap: break-word;
        display: flex;
        flex-wrap: wrap;
    }
}
</style>
